export const DEFAULT_COIN_ICON = "/coin.png";

export function creditPackageImageUrl(imageUrl: string | null | undefined): string {
  const url = imageUrl?.trim();
  return url || DEFAULT_COIN_ICON;
}
